export default __webpack_public_path__ + "static/media/domino_counter_screen_2.5685995a.png";